import type {
  AdsCapabilitySlot,
  AdsCapabilityVariables,
} from '@web-platform/shared-universal-types/src/network/banana/requestTypes/adsCapabilityRequestTypes';

export const HOMEPAGE_ADS_CAPABILITY_EXPERIENCE: AdsCapabilityVariables['experience'] =
  'EXPERIENCE_HOMEPAGE';

export const HOMEPAGE_ADS_CAPABILITY_VERTICAL: AdsCapabilityVariables['vertical'] =
  'VERTICAL_FLIGHTS';

export const HOMEPAGE_ADS_CAPABILITY_SLOTS_MOBILE: AdsCapabilitySlot[] = [
  { namedSlot: 'NAMED_SLOT_HERO' },
  { namedSlot: 'NAMED_SLOT_SLOT' },
];

export const HOMEPAGE_ADS_CAPABILITY_SLOTS_DESKTOP: AdsCapabilitySlot[] = [
  { namedSlot: 'NAMED_SLOT_HERO' },
  { numberedSlot: 'NUMBERED_SLOT_ONE' },
];

type BuildHomepageAdsCapabilityVariablesInput = Omit<
  AdsCapabilityVariables,
  'experience' | 'vertical' | 'slots'
> & {
  isMobilePhone: boolean;
};

export const buildHomepageAdsCapabilityVariables = ({
  isMobilePhone,
  ...common
}: BuildHomepageAdsCapabilityVariablesInput): AdsCapabilityVariables => ({
  ...common,
  experience: HOMEPAGE_ADS_CAPABILITY_EXPERIENCE,
  vertical: HOMEPAGE_ADS_CAPABILITY_VERTICAL,
  slots: isMobilePhone
    ? HOMEPAGE_ADS_CAPABILITY_SLOTS_MOBILE
    : HOMEPAGE_ADS_CAPABILITY_SLOTS_DESKTOP,
});
